import { Alert, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import type { UploadFailureDisplay } from "../../services/ragDocumentApi";

export type DocumentUploadFailuresAlertProps = {
  failures: UploadFailureDisplay[];
  onDismiss?: () => void;
};

export function DocumentUploadFailuresAlert({
  failures,
  onDismiss,
}: DocumentUploadFailuresAlertProps) {
  const { t } = useTranslation();

  if (!failures.length) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        onDismiss ? (
          <IconButton
            aria-label={t("opva.close", { defaultValue: "Close" })}
            color="inherit"
            size="small"
            onClick={onDismiss}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        ) : undefined
      }
    >
      <Typography variant="body2" fontWeight={600} gutterBottom>
        {failures.length === 1
          ? t("opva.dmUploadFailuresTitleOne", {
              defaultValue: "1 file was not uploaded:",
            })
          : t("opva.dmUploadFailuresTitleMany", {
              defaultValue: "{{count}} files were not uploaded:",
              count: failures.length,
            })}
      </Typography>
      {failures.map((f) => (
        <Typography key={f.fileName} variant="caption" display="block">
          <strong>{f.fileName}</strong>
          {f.reason ? ` — ${f.reason}` : null}
          {f.matchingFileName ? (
            <>
              {" "}
              {t("opva.dmUploadMatchingFile", {
                defaultValue: "Matching file:",
              })}{" "}
              <strong>{f.matchingFileName}</strong>
            </>
          ) : null}
        </Typography>
      ))}
    </Alert>
  );
}
